import styled from "styled-components";

const Container = styled.div`
  background-color: white;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
`;

const Input = styled.input`
  border: none;
  outline: none;
  width: 100%;
  margin-left: 6px;
`;

const ClearButton = styled.button`
  border: none;
  outline: none;
  background: none;
  padding: 0;
  margin: 0;
  height: auto;
`;

const SearchIconContainer = styled.button`
  background-color: rgb(245, 245, 245);
  border: 1px solid #e9e9e9;
  border-radius: 20px;
  padding: 5px 10px;
  height: auto;
`;

const modules = {
  Container,
  Input,
  ClearButton,
  SearchIconContainer,
};

export default modules;
